import { createAction, props } from '@ngrx/store';
import {
  HiddenFieldsByModule,
  IFieldVisibilityCatalog,
} from './field-visibility.types';

export const loadHiddenFieldsFromLogin = createAction(
  '[Field Visibility] Load Hidden Fields From Login',
  props<{ hiddenFields: HiddenFieldsByModule }>()
);

export const clearHiddenFields = createAction(
  '[Field Visibility] Clear Hidden Fields'
);

export const loadFieldVisibilityCatalog = createAction(
  '[Field Visibility] Load Catalog'
);

export const loadFieldVisibilityCatalogSuccess = createAction(
  '[Field Visibility] Load Catalog Success',
  props<{ catalog: IFieldVisibilityCatalog }>()
);

export const loadFieldVisibilityCatalogFailure = createAction(
  '[Field Visibility] Load Catalog Failure'
);
